import { watch } from 'vue';
import { activeBrand } from '@/themes/primevue/brandState.js';
const BAYHIVE_FAVICON_SIZES = new Set(['16x16', '32x32', '48x48']);
const BAYHIVE_FAVICON_PATTERN = /(?:^|\/)bayhive-favicon(?:-(?:light|dark))?-(?:16x16|32x32|48x48)\.png(?:[?#].*)?$/;
const CLEANUP_KEY = '__bayhiveFaviconCleanup';

function isBayhiveFavicon(link) {
  const size = link.getAttribute('sizes');
  const href = link.getAttribute('href') || '';

  return BAYHIVE_FAVICON_SIZES.has(size) && (
    link.hasAttribute('data-bayhive-favicon') || BAYHIVE_FAVICON_PATTERN.test(href)
  );
}

function themedIconUrl(link, theme) {
  const profile = activeBrand.value;
  if (profile.application === 'bayhive' && profile.id !== 'bayhive') {
    return profile.favicons?.[theme] || profile.logos?.[theme === 'dark' ? 'iconDark' : 'iconLight'] || 'data:,';
  }
  const size = link.getAttribute('sizes');
  const attribute = theme === 'dark' ? 'data-dark-icon' : 'data-light-icon';

  return link.getAttribute(attribute) || `/bayhive-favicon-${theme}-${size}.png`;
}

function syncBayhiveFavicons(theme = document.documentElement.getAttribute('data-bs-theme')) {
  const activeTheme = theme === 'dark' ? 'dark' : 'light';

  document.querySelectorAll('link[rel~="icon"][sizes]').forEach((link) => {
    if (!isBayhiveFavicon(link)) {
      return;
    }

    const href = themedIconUrl(link, activeTheme);

    link.setAttribute('data-bayhive-favicon', '');

    if (link.getAttribute('href') !== href) {
      link.setAttribute('href', href);
    }
  });
}

export function initBayhiveFavicon() {
  const hasBayhiveFavicon = Array.from(
    document.querySelectorAll('link[rel~="icon"][sizes]'),
  ).some(isBayhiveFavicon);

  if (!hasBayhiveFavicon) {
    return;
  }

  window[CLEANUP_KEY]?.();

  const onThemeChange = (event) => {
    syncBayhiveFavicons(event.detail?.theme);
  };
  const observer = new MutationObserver(() => syncBayhiveFavicons());

  window.addEventListener('themechange', onThemeChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-bs-theme'],
  });

  const stopBrandWatch = watch(activeBrand, () => syncBayhiveFavicons());
  window[CLEANUP_KEY] = () => {
    stopBrandWatch();
    window.removeEventListener('themechange', onThemeChange);
    observer.disconnect();
  };

  syncBayhiveFavicons();
}
